<script setup>
import { computed } from 'vue';
import FormSelect from 'v3/components/Form/Select.vue';
import { useConfig } from 'dashboard/composables/useConfig';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  value: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['change']);

const { enabledLanguages } = useConfig();
const { t } = useI18n();

const languageOptions = computed(() => {
  const list = (enabledLanguages || [])
    .slice()
    .sort((l1, l2) => l1.iso_639_1_code.localeCompare(l2.iso_639_1_code))
    .map(lang => ({
      value: lang.iso_639_1_code,
      label: lang.name,
    }));

  return [
    {
      value: '',
      label: t(
        'PROFILE_SETTINGS.FORM.INTERFACE_SECTION.UI_LANGUAGE.USE_ACCOUNT_DEFAULT'
      ),
    },
    ...list,
  ];
});

const selectedValue = computed({
  get: () => props.value || '',
  set: value => {
    emit('change', value);
  },
});
</script>

<template>
  <div class="flex gap-2 justify-between w-full items-start">
    <div>
      <label class="text-n-gray-12 font-medium leading-6 text-sm">
        {{ label }}
      </label>
      <p class="text-n-gray-11">
        {{ description }}
      </p>
    </div>
    <FormSelect
      v-model="selectedValue"
      name="uiLanguage"
      spacing="compact"
      class="min-w-28 mt-px"
      :value="selectedValue"
      :options="languageOptions"
      label=""
    >
      <option
        v-for="option in languageOptions"
        :key="option.value"
        :value="option.value"
        :selected="option.value === selectedValue"
      >
        {{ option.label }}
      </option>
    </FormSelect>
  </div>
</template>
